export default "__VITE_ASSET__7d627e50__"